import { ActionType } from '../../types';

export const GetSubscriptionActions = {
    getSubscriptionStarted: () =>
        ({
            type: 'GetSubscription/Started',
        } as const),

    getSubscriptionSucceeded: (message: string, data: {}, subscriptionUrl: string) =>
        ({
            type: 'GetSubscription/Succeeded',
            payload: { message, data, subscriptionUrl },
        } as const),

    getSubscriptionFailed: (errorCode: string) =>
        ({
            type: 'GetSubscription/Failed',
            payload: { errorCode },
        } as const),

    getSubscriptionUnmounted: () =>
        ({
            type: 'GetSubscription/Unmounted',
        } as const),

    getPartNumberStarted: () =>
        ({
            type: 'GetPartNumber/Started',
        } as const),

    getPartNumberSucceeded: (data: {}) =>
        ({
            type: 'GetPartNumber/Succeeded',
            payload: { data },
        } as const),

    getPartNumberFailed: (errorCode: string) =>
        ({
            type: 'GetPartNumber/Failed',
            payload: { errorCode },
        } as const),

    getPartNumberUnmounted: () =>
        ({
            type: 'GetPartNumber/Unmounted',
        } as const),

    getSiteSubscriptionStarted: () =>
        ({
            type: 'GetSiteSubscription/Started',
        } as const),

    getSiteSubscriptionSucceeded: (data: {}) =>
        ({
            type: 'GetSiteSubscription/Succeeded',
            payload: { data },
        } as const),

    getSiteSubscriptionFailed: (errorCode: string) =>
        ({
            type: 'GetSiteSubscription/Failed',
            payload: { errorCode },
        } as const),

    getSiteSubscriptionUnmounted: () =>
        ({
            type: 'GetSiteSubscription/Unmounted',
        } as const),

    mappingSiteIdActivationIdStarted: () =>
        ({
            type: 'MappingSiteIdActivationId/Started',
        } as const),

    mappingSiteIdActivationIdSucceeded: (
        message: string,
        data: {},
        subscriptionType: string,
        quantity: number,
        expirationDate: string | null
    ) =>
        ({
            type: 'MappingSiteIdActivationId/Succeeded',
            payload: { message, data, subscriptionType, quantity, expirationDate },
        } as const),

    mappingSiteIdActivationIdFailed: (errorCode: string) =>
        ({
            type: 'MappingSiteIdActivationId/Failed',
            payload: { errorCode },
        } as const),

    mappingSiteIdActivationIdUnmounted: () =>
        ({
            type: 'MappingSiteIdActivationId/Unmounted',
        } as const),

    createEntitlementStarted: () =>
        ({
            type: 'CreateEntitlement/Started',
        } as const),

    createEntitlementSucceeded: (message: string, data: {}) =>
        ({
            type: 'CreateEntitlement/Succeeded',
            payload: { message, data },
        } as const),

    createEntitlementFailed: (errorCode: string) =>
        ({
            type: 'CreateEntitlement/Failed',
            payload: { errorCode },
        } as const),

    createEntitlementUnmounted: () =>
        ({
            type: 'CreateEntitlement/Unmounted',
        } as const),
};

export type GetSubscriptionActions = ActionType<typeof GetSubscriptionActions>;
